import { Box, Typography, } from '@mui/material';

import trustImage01 from 'assets/img/osperb/trustAppreciation/trust01.jpg';
import trustImage02 from 'assets/img/osperb/trustAppreciation/trust02.jpg';
import trustImage03 from 'assets/img/osperb/trustAppreciation/trust03.jpg';
import trustImage04 from 'assets/img/osperb/trustAppreciation/trust04.jpg';
import { E_COMMERCE_STYLES } from 'components/ECommerce/config';
import { useEffect, useRef } from 'react';
import osperbBannerWeb from '../../assets/img/mobileLanding/osperb-website-lap.jpg';
import osperbBanner from '../../assets/img/mobileLanding/osperb-banner.jpg';
import DiscussProjectSection from '../CaseStudy/elements/DiscussProjectSection';
import MilestoneSection from './MilestoneSection';
import useDevice from 'hooks/useDevice';

import lifeAtOsperb1 from 'assets/img/osperb/life_at_osperb/1.jpg';
import lifeAtOsperb2 from 'assets/img/osperb/life_at_osperb/2.jpg';
import lifeAtOsperb3 from 'assets/img/osperb/life_at_osperb/3.jpg';
import lifeAtOsperb5 from 'assets/img/osperb/life_at_osperb/5.jpg';
import lifeAtOsperb7 from 'assets/img/osperb/life_at_osperb/7.jpg';


// Slider image interface
interface SliderImage {
  id: number;
  src: string;
  alt: string;
}

function Section10({ type }: { type: string }) {
  const { isMobile } = useDevice();
  // Slider images for "Trust, Appreciation & Recognition" section
  const sliderImages: SliderImage[] = [
    {
      id: 2,
      src: trustImage02,
      alt: 'Award Winning Custom Software Development Company Kerala',
    },
    {
      id: 1,
      src: trustImage01,
      alt: 'Top Rated ERP NEXT Development Company Malappuram',
    },

    {
      id: 3,
      src: trustImage03,
      alt: 'Best Web & Mobile App Developers Kerala Recognition',
    },
    {
      id: 4,
      src: trustImage04,
      alt: 'Business Automation Software Experts Kerala',
    },
  ];

  const lifeAtOsperbImages: SliderImage[] = [
    {
      id: 2,
      src: lifeAtOsperb1,
      alt: 'Life at Osperb - Software Development Team Kerala',
    },
    {
      id: 1,
      src: lifeAtOsperb2,
      alt: 'Osperb Team Working on Custom Enterprise Solutions',
    },

    {
      id: 3,
      src: lifeAtOsperb3,
      alt: 'Osperb Office - Best IT Company Malappuram',
    },
    {
      id: 4,
      src: lifeAtOsperb5,
      alt: 'Osperb Team Collaboration on ERP NEXT Projects',
    },
    {
      id: 5,
      src: lifeAtOsperb7,
      alt: 'Osperb Team Building Mobile Applications for Clients',
    },
  ];
  const infiniteLifeAtOsperbImages = [...lifeAtOsperbImages, ...lifeAtOsperbImages, ...lifeAtOsperbImages];


  // Create a tripled array for infinite scroll illusion
  const infiniteImages = [...sliderImages, ...sliderImages, ...sliderImages];
  const scrollRef = useRef<HTMLDivElement>(null);

  const handleScroll = () => {
    const container = scrollRef.current;
    if (!container) return;

    const { scrollLeft, children } = container;
    if (children.length === 0) return;

    // Calculate width of one set (based on the first item of the second set)
    // Adjust index based on original array length
    const firstItem = children[0] as HTMLElement;
    const secondSetStartItem = children[sliderImages.length] as HTMLElement;

    if (!firstItem || !secondSetStartItem) return;

    const singleSetWidth = secondSetStartItem.offsetLeft - firstItem.offsetLeft;

    // Tolerance for float calculations
    const threshold = 10;

    // If scrolled to the start of the first set (or further left/start), jump to start of second set
    if (scrollLeft <= threshold) {
      container.scrollLeft = singleSetWidth + scrollLeft;
    }
    // If scrolled to the start of the third set (or further right), jump back to start of second set
    else if (scrollLeft >= singleSetWidth * 2 - threshold) {
      container.scrollLeft = scrollLeft - singleSetWidth;
    }
  };

  const initializeScroll = () => {
    const container = scrollRef.current;
    if (container && container.children.length > 0) {
      const firstItem = container.children[0] as HTMLElement;
      const secondSetStartItem = container.children[sliderImages.length] as HTMLElement;

      if (firstItem && secondSetStartItem) {
        const singleSetWidth = secondSetStartItem.offsetLeft - firstItem.offsetLeft;

        // Only center if we are currently at 0 (start) to avoid disrupting user if they started scrolling
        if (container.scrollLeft === 0 && singleSetWidth > 0) {
          container.scrollLeft = singleSetWidth;
        }
      }
    }
  };

  useEffect(() => {
    initializeScroll();
  }, [sliderImages.length]);

  const handleImageLoad = () => {
    initializeScroll();
  };



  // Removed sliderSettings2

  return (
    <Box
      sx={{
        backgroundColor: '#fff',
        overflow: 'hidden',
        // maxWidth: E_COMMERCE_STYLES.container.maxWidthWeb,
        margin: E_COMMERCE_STYLES.container.mx,
      }}
    >
      <MilestoneSection type={type} />

      {/* ============ PART 2: Trust, Appreciation & Recognition ============ */}
      <Box
        sx={{
          paddingY: 5,
          position: 'relative',
          pb: 3,
        }}
      >
        {/* Title */}
        <Typography
          variant="h3"
          className="font-satoshi-bold"
          title="Award Winning Software Development Company Kerala"
          sx={{
            background: 'linear-gradient(270.11deg, #177BFF 23.63%, #0F1C3F 123.03%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontSize: '21px',
            lineHeight: '120%',
            textAlign: type === 'web' ? 'center' : 'start',
            mb: type === 'web' ? 2 : 1.5,
            px: 3,
          }}
        >
          Trust, Appreciation & Recognition
        </Typography>
        <Box
          ref={scrollRef}
          onScroll={handleScroll}
          sx={{
            overflowX: 'auto',
            whiteSpace: 'nowrap',
            px: 2,
            display: 'flex',
            gap: 1,
            scrollbarWidth: 'none',
            '&::-webkit-scrollbar': {
              display: 'none',
            },
          }}
        >
          {infiniteImages.map((image, index) => (
            <Box
              key={`${image.id}-${index}`}
              sx={{
                px: 0,
                flexShrink: 0,
              }}
            >
              <Box
                sx={{
                  position: 'relative',
                  borderRadius: '14px',
                  cornerShape: 'squircle',
                  overflow: 'hidden',
                  transition: 'border 0.3s ease',
                  height: '170px',
                  display: 'flex',
                }}
              >
                <Box
                  component="img"
                  src={image.src}
                  alt={image.alt}
                  onLoad={handleImageLoad}
                  sx={{
                    width: 'auto',
                    height: '100%',
                    display: 'block',
                    objectFit: 'cover',
                    maxWidth: 'max-content',
                  }}
                />
              </Box>
            </Box>
          ))}
        </Box>
      </Box>

      <Box sx={{ mb: 3, mt: "50px" }}>

        <Typography
          variant="h3"
          // className="font-satoshi-bold"
          sx={{
            background: 'linear-gradient(270.11deg, #177BFF 23.63%, #0F1C3F 123.03%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontSize: '21px',
            lineHeight: '120%',
            textAlign: type === 'web' ? 'center' : 'start',
            mb: type === 'web' ? 2 : 1.5,
            px: 3,
          }}
          className="font-typo"

        >
          Life at Osperb
        </Typography>

        <Box
          component="img"
          src={type === 'web' ? osperbBannerWeb : osperbBanner}
          alt="Osperb Team - Best Software Development Company in Malappuram"
          title="Osperb Team - ERP NEXT & Custom Software Experts"
          sx={{
            width: '100%',
            height: 'auto',
            display: 'block',
            objectFit: 'cover',
          }}
        />

        {/* // normal scroll slider */}
        <Box
          sx={{
            background: 'linear-gradient(180deg, #000 40%, transparent 100%)',
            overflowX: 'auto',
            whiteSpace: 'nowrap',
            px: 2,
            mt: isMobile ? "-10px" : "0",
            py: 2,
            display: 'flex',
            gap: 1,
            scrollbarWidth: 'none',
            '&::-webkit-scrollbar': {
              display: 'none',
            },
          }}
        >
          {infiniteLifeAtOsperbImages.map((image, index) => (
            <Box
              key={image.id}
              sx={{
                px: 0,
                flexShrink: 0,
              }}
            >
              <Box
                sx={{
                  position: 'relative',
                  borderRadius: '8px',
                  overflow: 'hidden',
                  transition: 'border 0.3s ease',
                  height: '170px',
                  width: '236px',
                }}
              >
                <Box
                  component="img"
                  src={image.src}
                  alt={image.alt}
                  sx={{
                    width: '100%',
                    height: '100%',
                    display: 'block',
                    objectFit: 'cover',
                  }}
                />
              </Box>
            </Box>
          ))}
        </Box>
        {/* <Box px={3} pt={2}>
          <OsperbShorts reels={reels} visibleItems={{ lg: 6.5, md: 6.5, sm: 3, xs: 2.5 }} />
        </Box> */}
      </Box>

      {/* ============ PART 3: Discuss Your Project With Us ============ */}
      <DiscussProjectSection type={type} />
    </Box>
  );
}

export default Section10;
